import { render, staticRenderFns } from "./Broadcasters.vue?vue&type=template&id=e5f5d918"
import script from "./Broadcasters.vue?vue&type=script&lang=js"
export * from "./Broadcasters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports